import { Moment } from 'moment';
import { Country } from '../address/country';

export class Foreign {
    id: number;
    passport: string;
    country: Country;
    entryDate: Moment;
}
